import { updatePassword } from 'aws-amplify/auth';

export const UpdatePassword = async ({
  newPassword,
  currentPassword,
}: {
  newPassword: string;
  currentPassword: string;
}) => {
  return updatePassword({
    oldPassword: currentPassword,
    newPassword,
  });
};
